export default class NestableError extends Error {
    constructor(message, nestedError) {
        super(message);
        this.nestedError = nestedError;
    }
    toString() {
        if (this.nestedError) {
            return `${this.message} --> ${this.nestedError}`;
        }
        else {
            return this.message;
        }
    }
}
//# sourceMappingURL=NestableError.js.map